
// (function() {

//     function attachListeners() {
//         const variableContainer = document.querySelector('.gfbVolumeDiscountLabelParentContainer');
//         const popUpContainer = document.querySelector('.product-popup-modal__button');

//         if (!variableContainer || !popUpContainer) {
//             return false;
//         }

//         const popUpElement = popUpContainer.closest('modal-opener') || popUpContainer;
//         variableContainer.insertAdjacentElement('afterend', popUpElement);
//         popUpContainer.style.opacity = '1';
//         popUpContainer.style.marginTop = '1rem';
//         popUpContainer.style.fontSize = '14px';
//         return true;

//     }

//     function init() {
//         if (attachListeners()) {
//             return;
//         }

//         const observer = new MutationObserver(() => {
//             if (attachListeners()) {
//                 observer.disconnect();
//             }
//         });

//         observer.observe(document.body, { childList: true, subtree: true });
//     } 

//     if (document.readyState === 'loading') {
//         window.addEventListener('DOMContentLoaded', init);
//     } else {
//         init();
//     }

// })();

// Change the text of the "Add to Cart" 

let textSizeGoCollection = document.querySelectorAll('.product-form__input  span');

textSizeGoCollection.forEach((element) => {
  if (element.textContent.includes('Choose your fit')) {
    element.textContent = element.textContent.replace('Choose your fit', 'Size');
  }
});